export default __webpack_public_path__ + "static/media/community.654bb94f.png";